import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import {
  NgxScannerQrcodeComponent,
  ScannerQRCodeConfig,
  ScannerQRCodeDevice,
  ScannerQRCodeResult,
} from 'ngx-scanner-qrcode';
import { Observable, Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';

// INTERFACES
import { LocalStorageKeys } from 'v2/modules/shared/interfaces/localstorage.interface';

import { IScannerResponse } from '../../../shared/interfaces/common.interface';

// LIBS

// SERVICES
import { ScannerServiceApiService } from './../../../shared/services/api/scanner-service-api.service';

@Component({
  selector: 'lum-ui-scanner',
  templateUrl: './ui-scanner.component.html',
  styleUrls: ['./ui-scanner.component.scss'],
})
export class UiScannerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  activeDevice :string;

  @Input()
  scannerConfig :ScannerQRCodeConfig = {
    fps: 10,
    vibrate: 300,
    isBeep: true,
    constraints: { audio: false, video: true },
  };

  @Output()
  scanSuccess = new EventEmitter<any>();

  @ViewChild(NgxScannerQrcodeComponent, { static: false })
  scanner :NgxScannerQrcodeComponent;

  locations$ :Observable<any>; // TODO: Create interface for location
  scannedValue :string;
  loading :boolean = false;
  currentDeviceId :string;
  shouldBeep :boolean = true;

  private destroy$ = new Subject<void>();
  constructor(
    private scannerServiceApiService :ScannerServiceApiService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.loading = true;
  }

  ngOnDestroy() :void {
    this.destroy$.next();
    this.destroy$.complete();
    this.scanner.stop();
  }

  ngAfterViewInit() {
    this.scanner.isReady.pipe(delay(1000), takeUntil(this.destroy$)).subscribe({
      next: () => {
        if (this.activeDevice) {
          this.scanner.playDevice(this.activeDevice);
        } else {
          this.handle(this.scanner, 'start');
        }
        this.loading = false;
        this.cd.detectChanges();
      },
      error: (err) => {
        this.loading = false;

        return err;
      },
    });
  }

  handle(scanner :any, fn :string) :void {
    const playDeviceFacingBack = (devices :ScannerQRCodeDevice[]) => {
      // front camera or back camera check here!
      const device = devices.find((f) => /back|rear|environment/gi.test(f.label)); // Default Back Facing Camera
      const activeDevice = this.currentDeviceId
        ? this.currentDeviceId
        : device
          ? device.deviceId
          : devices[0].deviceId;
      scanner.playDevice(activeDevice);
    };

    if (fn === 'start') {
      scanner[fn](playDeviceFacingBack);
    } else {
      scanner[fn]();
    }
  }

  onScanned(result :ScannerQRCodeResult[]) :void {
    this.shouldBeep = false;
    if (!result || result.length <= 0 || !result[0]) {
      return;
    }

    //If result.typeName = "ZBAR_EAN13" and the first character is a 0, remove the 0.  It is a UPC-A code.
    if (
      result[0]?.typeName === 'ZBAR_EAN13' &&
      result[0]?.value.charAt(0) === '0'
    ) {
      result[0].value = result[0].value.substring(1);
    }

    if (this.scannedValue === result[0].value) {
      return;
    }
    this.scannedValue = result[0].value;

    this.scannerServiceApiService
      .getScannerData(this.scannedValue)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data :IScannerResponse) => {
          this.shouldBeep = true;
          this.scanSuccess.emit({
            ...data,
            scannedValue: this.scannedValue,
          });
        },
        error: (err) => {
          this.loading = false;

          return err;
        },
      });
  }
}
